import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
} from "@mui/material";

interface LoadingDialogProps {
  open: boolean;
  title: string;
  msg?: string;
}

const LoadingDialog = (props: LoadingDialogProps) => {
  return (
    <Dialog open={props.open} maxWidth="xs">
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        {props.msg && <DialogContentText>{props.msg}</DialogContentText>}
      </DialogContent>
      <LinearProgress />
    </Dialog>
  );
};

export default LoadingDialog;
